import React from 'react';
import styles from '../../styles/VibesPlayer.module.scss';

interface VibesPlayerProps {
  title: string;
  url: string;
}

const VibesPlayer: React.FC<VibesPlayerProps> = ({ title, url }) => {
  if (!url) return null;

  return (
    <div className={styles['video-section']}>
      <h3>Current Vibes: {title}</h3>
      <div className={styles['video-wrapper']}>
        <iframe
          width="560"
          height="315"
          src={url}
          title="Vibes Player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
};

export default VibesPlayer;
